import React from 'react'

import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { FormattedMessage } from 'react-intl'
import { bindActionCreators } from 'redux'

import PropTypes from 'prop-types'

import * as selectors from '../endgame.selectors'
import * as quizzesSelectors from '../../../Quizzes/quizzes.selectors'
import * as miningSelectors from '../../../Mining/mining.selectors'
import * as firebaseSelectors from '../../../../Core/Firebase/firebase.selectors'
import * as battlesSelectors from '../../../Battles/battles.selectors'
import * as savePointSelector from '../../../SavePoint/savePoint.selectors'

import * as actions from '../endgame.actions'

import * as utils from '../endgame.utils'
import * as quizzUtils from '../../../Quizzes/quizzes.utils'

class Summary extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    const { report, userData, playerData, questions, battles, totalLikes } = this.props
    let correctAnswers = quizzUtils.getTotalCorrectAnswers(questions.answers)
    let battleStats = utils.countBattleStats(battles.allUserBattles, userData.id)
    const correctPercentage = questions.answers.length
      ? (correctAnswers * 100) / questions.answers.length
      : 0

    return (
      <div className="endgame--summary">
        <div className="endgame--summary__col">
          <div className="endgame--summary__head">
            <span className="value">{playerData.coins}</span>
            <span className="text">
              <FormattedMessage id="endGame.title" />
            </span>
            <span className="icon-coin"> </span>
          </div>
          <ul className="endgame--summary__list">
            <li>
              <span className="value">{totalLikes}</span>
              <span className="text">
                <FormattedMessage id="endGame.likes" />
              </span>
            </li>
            <li>
              <span className="value">{report.disputed}</span>
              <span className="text">
                <FormattedMessage id="endGame.claimed" />
              </span>
            </li>
            <li>
              <span className="value">{report.disputedToMe}</span>
              <span className="text">
                <FormattedMessage id="endGame.claims" />
              </span>
            </li>
            <li>
              <span className="value">
                {battles.allUserBattles ? battles.allUserBattles.length : 0}
              </span>
              <span className="text">
                <FormattedMessage id="endGame.challenges" />
              </span>
            </li>
            <li>
              <span className="value">{battleStats.wonBuildings}</span>
              <span className="text">
                <FormattedMessage id="endGame.stolen" />
              </span>
            </li>
            <li>
              <span className="value">{battleStats.lostBuildings}</span>
              <span className="text">
                <FormattedMessage id="endGame.lost" />
              </span>
            </li>
          </ul>
        </div>
        <div className="endgame--summary__col">
          <div className="endgame--summary__head">
            <span className="value">{playerData.settlers}</span>
            <span className="text">
              <FormattedMessage id="endGame.settlers" />
            </span>
            <span className="icon-colonos"> </span>
          </div>
          <div className="endgame--list__block">
            <ul className="endgame--summary__list">
              <li>
                <span className="value">{playerData.happiness}</span>
                <span className="icon-happiness"></span>
              </li>
              <li>
                <span className="value">{playerData.food}</span>
                <span className="icon-feed"></span>
              </li>
              <li>
                <span className="value">{playerData.energy}</span>
                <span className="icon-energy"></span>
              </li>
            </ul>
            <ul className="endgame--summary__list">
              <li>
                <span className="icon-houses"></span>
                <span className="value">{playerData.home}</span>
              </li>
              <li>
                <span className="icon-o2"></span>
                <span className="value">{playerData.oxygen}</span>
              </li>
              <li>
                <span className="icon-water"></span>
                <span className="value">{playerData.water}</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="endgame--summary__col">
          <div className="endgame--summary__head">
            <span className="value">{correctPercentage.toFixed(1)}%</span>
            <span className="text">
              <FormattedMessage id="endGame.hits" />
            </span>
            <span className="icon-doing"> </span>
          </div>
          <ul className="endgame--summary__list">
            <li>
              <span className="text">
                <FormattedMessage id="endGame.antimatter" />
              </span>
              <span className="value">{playerData.antimatter}</span>
            </li>
            <li>
              <span className="text">
                <FormattedMessage id="endGame.answered" />
              </span>
              <span className="value">{questions.answers.length}</span>
            </li>
            <li>
              <span className="text">
                <FormattedMessage id="endGame.created" />
              </span>
              <span className="value">{questions.created.length}</span>
            </li>
            <li>
              <span className="text">
                <FormattedMessage id="endGame.debates" />
              </span>
              <span className="value">{report.debated}</span>
            </li>
          </ul>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    totalLikes: miningSelectors.getTotalLikes(state),
    playerData: firebaseSelectors.getPlayerData(state),
    userData: firebaseSelectors.getUserData(state),
    report: selectors.report(state),
    questions: quizzesSelectors.getQuestionList(state),
    battles: battlesSelectors.getBattles(state),
    disputeList: quizzesSelectors.getDisputesList(state),
    surveyActive: savePointSelector.isSurveyCompleted(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getReports: bindActionCreators(actions.loadData, dispatch),
  }
}

Summary.propTypes = {
  report: PropTypes.object,
  playerData: PropTypes.object,
  userData: PropTypes.object,
  questions: PropTypes.object,
  battles: PropTypes.object,
  totalLikes: PropTypes.number,
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(Summary))
